export class AuthenticationFailed extends Error { }
export class AuthenticationBadRequest extends Error { }
export class AuthenticationServerError extends Error { }
export class AuthenticationUnconfirmedEmail extends Error { }
export class IdentityCreationFailed extends Error { }
export class IdentityCreationBadRequest extends Error { }
export class IdentityCreationConflict extends Error { }
export class VaultDataMissing extends Error { }